import React__default from 'react';
import { Operations } from '@grandvisionhq/carts-v2';

const useUpdateCartCache = ()=>{
    const updateCacheWithCart = React__default.useCallback(({ cart , cache  })=>{
        cache.writeQuery({
            query: Operations.Queries.GET_CART,
            variables: {
                id: cart.id
            },
            data: {
                getCart: {
                    __typename: 'CartResponse',
                    cart,
                    validationErrors: null
                }
            }
        });
    }, []);
    return {
        updateCacheWithCart
    };
};

export { useUpdateCartCache };
//# sourceMappingURL=use-update-cart-cache.js.map
